import { Component } from 'react';
import { Tooltip } from 'react-tooltip';
import { connect } from 'react-redux';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { Button as ModalButton, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from 'reactstrap';

import { toast } from 'react-toastify';

import Button from '../../components/button/button';

import { getGames } from '../../../modules/system/game';
import { getGameSessions, resetGameSessionState } from '../../../modules/game_session';
import {
  unassignPlayerFromSession,
  getTherapistGameSessionBank,
  assignPlayerToSession,
} from '../../../modules/game_session_api';
import { getPositions } from '../../../modules/system/position';
import { getSkills } from '../../../modules/system/skill';

import { setPageTitle } from '../../../modules/application/pages';

import { parseQuery } from '../../../transformations/queryString';
import { getPlayers } from '../../../modules/player';
import { getMyPlayers } from '../../../modules/player_api';
import { withWhiteLabelContext } from 'react-whitelabel';

import './therapist-session-bank.css';

class TherapistSessionBank extends Component {
  constructor(props) {
    super(props);
    this.OWNED_SESSION_TYPE = 1;
    this.READY_MADE_SESSION_TYPE = 2;
    this.state = {
      showAssignModal: false,
      currentSession: {},
      sessions: [],
      players: props.players,
    };
    this.removePlayerFromSession = this.removePlayerFromSession.bind(this);
    this.addPlayerToSession = this.addPlayerToSession.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { dispatch, label, currentUserId } = this.props;
    dispatch(resetGameSessionState());
    dispatch(setPageTitle('My Sessions'));
    dispatch(getGames([]));
    dispatch(getPlayers([{ owner_id: currentUserId }]));
    dispatch(getMyPlayers());
    dispatch(getPositions([{ platform_id: `${label.platform.platform_id}` }]));
    dispatch(getSkills());
  }

  async componentDidMount() {
    const sessionsResponse = await getTherapistGameSessionBank();
    let sessions;
    if (sessionsResponse.data) {
      sessions = sessionsResponse.data.sessions;
    } else {
      sessions = [];
    }

    this.setState({ sessions: sessions });

    this.props.dispatch(
      getGameSessions([{ owner_id: this.props.currentUserId }, { is_archived: false }, { is_template: true }], '-id')
    );

    const queryString = parseQuery(window.location);

    if (queryString && queryString.message) {
      const message = queryString.message;

      toast.success(unescape(message), {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  render() {
    const { sessions } = this.state;

    return (
      <Row>
        <Link to="/gameSession">
          <Button
            className="ml-4 my-3"
            text="Create Session"
            color="primary"
            onClick={() => {
              this.props.dispatch(resetGameSessionState());
            }}
          />
        </Link>
        <Table bordered className="mx-4">
          <thead>
            <tr className="pl-2 text-left">
              <th className="m-0 p-0">Name</th>
              <th className="m-0 p-0">Players</th>
              <th className="m-0 p-0">Skills</th>
              <th className="m-0 p-0">Games</th>
            </tr>
          </thead>
          <tbody>
            {sessions &&
              sessions.map((gameSession) => (
                <tr key={'game_session_' + gameSession.id} className="text-left" title={gameSession.notes}>
                  <td className="m-1 p-1">
                    {gameSession.name ? gameSession.name : '<No Name>'}

                    {gameSession.type === this.READY_MADE_SESSION_TYPE ? (
                      <span className="ready_made_session_sign"> RESTORE Recommended</span>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="m-1 p-1">{this.prepareSessionAssignedPlayers(gameSession.players)}</td>
                  <td className="m-1 p-1">{this.gameSessionSkills(gameSession.skills, this.props.skills)}</td>
                  <td className="m-1 p-1">{this.gameSessionGames(gameSession.games)}</td>
                  <td className="m-1 p-1 text-center" style={{ width: 120 }}>
                    <Button
                      text="Assign"
                      className="btn-sm green_button"
                      onClick={() => {
                        this.setState({
                          gameSession: gameSession,
                          showAssignModal: true,
                        });
                      }}
                      color="secondary"
                    />

                    {this.props.user.currentUserId === gameSession.owner_id && (
                      <NavLink
                        to={{
                          pathname: `/gameSession/${gameSession.id}`,
                          gameSession: gameSession,
                        }}
                      >
                        <Button className="ml-1 btn-sm" text="Edit" color="primary" />
                      </NavLink>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
        <Modal isOpen={this.state.showAssignModal} className={this.props.className} backdrop={this.state.backdrop}>
          <ModalHeader>
            Manage Players for Session
            <br />
            <span className="font-weight-bold">{this.state.gameSession && this.state.gameSession.name}</span> to
            Player(s)
          </ModalHeader>
          <ModalBody>
            <span className="font-weight-bold">Assigned Players</span>
            <br />
            <div className="dialog_player_list">{this.getAssignedPlayers()}</div>
            <hr />
            <span className="font-weight-bold">Unassigned Players</span>
            <br />
            <div className="dialog_player_list">{this.getAvailablePlayers()}</div>
          </ModalBody>
          <ModalFooter>
            <ModalButton
              className="ml-3"
              color="secondary"
              onClick={() => {
                this.setState({
                  showAssignModal: false,
                });
              }}
            >
              Done
            </ModalButton>
          </ModalFooter>
        </Modal>
      </Row>
    );
  }

  prepareSessionAssignedPlayers(gameSessionPlayers) {
    const _players = [];
    const _otherPlayers = [];

    let otherPlayersElement = <span></span>;
    if (gameSessionPlayers.length > 5) {
      for (let i = 0; i < gameSessionPlayers.length; i++) {
        if (i >= 5) {
          _otherPlayers.push(gameSessionPlayers[i].name);
        } else {
          _players.push(gameSessionPlayers[i].name);
        }

        const parsedOthers = _otherPlayers.join('<br/>');

        otherPlayersElement = (
          <span>
            {' '}
            And{' '}
            <span
              className="session_other_players"
              data-tip={parsedOthers}
              data-delay-show="0"
              data-event="click"
              data-html={true}
            >
              <b>{_otherPlayers.length} others</b>
            </span>
          </span>
        );
      }
    } else {
      for (let i = 0; i < gameSessionPlayers.length; i++) {
        _players.push(gameSessionPlayers[i].name);
      }
    }

    return (
      <span>
        {_players.join(', ')}
        {otherPlayersElement}
        <Tooltip place="top" variant="dark" />
      </span>
    );
  }

  getAssignedPlayers() {
    if (!this.state.gameSession) {
      return;
    }
    const _players = [];
    const currentGameSession = this.state.gameSession;
    const players = currentGameSession.players;
    for (let i = 0; i < players.length; i++) {
      const currentPlayer = players[i];
      _players.push(
        <div className="player_dialog_player" key={'player_' + currentPlayer.id}>
          <Button
            className="ml-3"
            text="Remove"
            onClick={() => {
              this.removePlayerFromSession(this.state.gameSession, currentPlayer.id);
            }}
            color="warning"
          />
          <span className="ml-2">{currentPlayer.name}</span>
          <br />
        </div>
      );
    }

    return _players;
  }

  async removePlayerFromSession(gameSession, playerId) {
    const gameSessionID = gameSession.id;
    const updatedPlayersList = gameSession.players.filter((player) => {
      return player.id !== playerId;
    });

    // const updatedGameSession = {
    //     players: updatedPlayersList
    // };

    const unassignResponse = await unassignPlayerFromSession(playerId, gameSessionID);
    // await getEntity(this.props.dispatch,
    //     updateGameSession(gameSession.id, updatedGameSession));

    if (unassignResponse && unassignResponse.data && unassignResponse.data.success) {
      toast.success('Player has been removed from the session.', { position: toast.POSITION.TOP_CENTER });
      const _gameSession = this.state.gameSession;
      _gameSession.players = updatedPlayersList;
      this.setState({
        gameSession: _gameSession,
      });
    } else {
      toast.warn('Something went wrong... please try again', { position: toast.POSITION.TOP_CENTER });
    }
  }

  findPlayerInGameSession(gameSession, playerID) {
    for (const index in gameSession.players) {
      const currentPlayer = gameSession.players[index];

      if (currentPlayer.id === playerID) {
        return true;
      }
    }

    return false;
  }

  getAvailablePlayers() {
    if (!this.props.ownedPlayers) {
      return;
    }

    return this.props.ownedPlayers
      .filter((player) => {
        if (player.owner !== this.props.currentUserId) {
          return false;
        }

        return (
          this.state.gameSession &&
          this.state.gameSession.players &&
          !this.findPlayerInGameSession(this.state.gameSession, player.id)
        );
      })
      .map((player) => {
        return (
          <div className="player_dialog_player" key={'player_' + player.id}>
            <Button
              className="ml-3"
              text="Add"
              onClick={() => {
                this.addPlayerToSession(this.state.gameSession, player);
              }}
              color="primary"
            />
            <span className="ml-2">{player.name}</span>
            <br />
          </div>
        );
      });
  }

  async addPlayerToSession(gameSession, player) {
    const playerID = player.id;
    const gameSessionID = gameSession.id;

    const playerIDs = [];
    const updatedPlayersList = gameSession.players;
    updatedPlayersList.push(player);

    for (let i = 0; i < updatedPlayersList.length; i++) {
      playerIDs.push(updatedPlayersList[i].id);
    }

    // const updatedGameSession = {
    //     players: playerIDs
    // };

    const assignResponse = await assignPlayerToSession(playerID, gameSessionID);
    if (assignResponse && assignResponse.data && assignResponse.data.success) {
      toast.success('Player has been added to the session.', { position: toast.POSITION.TOP_CENTER });

      const _gameSession = this.state.gameSession;
      _gameSession.players = updatedPlayersList;

      this.setState({
        gameSession: _gameSession,
      });
    } else {
      toast.warn('Something went wrong... please try again', { position: toast.POSITION.TOP_CENTER });
    }
    //await getEntity(this.props.dispatch, updateGameSession(gameSession.id, updatedGameSession));
  }

  gameSessionGames = (gameSessionGames) => {
    const gamesArray = [];

    for (const index in gameSessionGames) {
      const currentGame = gameSessionGames[index];
      gamesArray.push(currentGame.name);
    }

    return gamesArray.join(', ');
  };

  gameSessionPlayers = (gameSessionPlayers) => {
    const _players = [];
    for (let i = 0; i < gameSessionPlayers.length; i++) {
      _players.push(gameSessionPlayers[i].name);
    }
    return _players.join(', ');
  };

  gameSessionSkills = (gameSessionSkills) => {
    const _skills = [];
    for (let i = 0; i < gameSessionSkills.length; i++) {
      _skills.push(gameSessionSkills[i].name);
    }

    return _skills.join(', ');
  };

  gameSessionPositions = (gameSessionPositions, positions) => {
    return positions
      .filter((position) => {
        return gameSessionPositions && gameSessionPositions.includes(position.id);
      })
      .map((position) => {
        return position.name;
      })
      .join(', ');
  };

  gameSessionLevels = (gameSessionSkills, skills) => {
    return skills
      .filter((skill) => {
        return gameSessionSkills.includes(skill.id);
      })
      .map((skill) => {
        return skill.name;
      })
      .join(', ');
  };
}

const withState = connect((state) => {
  const { game, game_session, player, position, skill, user } = state;

  const games = game.games;
  const gameSessions = game_session.game_sessions;
  const players = player.players;
  const ownedPlayers = player.owned_players;
  const positions = position.positions;
  const skills = skill.skills;

  return {
    games: games,
    user: user,
    ownedPlayers: ownedPlayers,
    gameSessions: gameSessions,
    players: players,
    positions: positions,
    skills: skills,
    currentUserId: user.currentUserId,
  };
});

export default withWhiteLabelContext(withRouter(withState(TherapistSessionBank)));
